import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import moment from 'moment';
import Hero from './Hero/Hero';
import NewsBody from './NewsBody/NewsBody';
import { currentPaginationPage } from '../../../store/actions';

const News = ({ news, isDesktop, page, currentPaginationPage }) => {

    return (
        <div className="news">
            <Helmet>
                <title>Hudson Pacific Properties News & Insights | HPP</title>
                <meta name="description" property="og:description" content="Stay up to date with what's happening at Hudson Pacific Properties." />
            </Helmet>
            <Hero />
            {news && <NewsBody isDesktop={isDesktop} page={page} currentPaginationPage={currentPaginationPage} news={news.map((post) => {
                return {
                    ...post,
                    published: moment(post.publishedDate),
                };
            }).sort(((a, b) => b.published.format('X') - a.published.format('X')))} />}
        </div>
    );
};

News.propTypes = {
    isDesktop: PropTypes.bool,
    news: PropTypes.array,
    page: PropTypes.number.isRequired,
    currentPaginationPage: PropTypes.func.isRequired,
};

export default connect(
    ({ screen, content, pagination }) => ({
        isDesktop: screen.isDesktop,
        page: pagination.page,
        news: content.news,
    }),
    { currentPaginationPage },
)(News);
